import { useContext } from "react";

import ViewSection from "./ViewSection";
import Loader from "./Loader";

import { AuthContext } from "../contexts/AuthContext";

import UserProfilePhoto from "./UserProfilePhoto";

import useUser from '../hooks/useUser';

import permissions from "../data/permissions.json";
import userService from "../services/userService";
import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const AdminUserView = ({ userId, onUpdateClicked, onDeleteClicked, onCloseClicked }) => {
  const { user } = useContext(AuthContext);

  const { data: adminData, isLoading, mutate } = useUser({ userId });

  const admin = adminData?.user;

  const handlePermissionTagClicked = async (permission) => {
    try {
      const userPermissions = admin?.permissions || [];

      let updatedPermissions = userPermissions.includes(permission)
        ? userPermissions.filter(p => p !== permission)
        : [...userPermissions, permission];

      if (updatedPermissions.length === 0) {
        updatedPermissions = ['none'];
      }

      await userService.updateUser({
        userId: admin._id,
        updateData: { permissions: updatedPermissions }
      });

      await mutate();

      console.log('Permissions updated successfully');
    } catch (error) {
      console.error("Error updating permissions:", error);
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:min-w-[900px]">
      <div className="flex items-center justify-between text-lg border-b bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <div className="flex items-center gap-2">
          <UserProfilePhoto
            photoUrl={admin?.profilePicture}
            fullName={admin?.fullName}
          />

          <p>{admin?.fullName}</p>
        </div>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex flex-col gap-2 border-b p-4">
        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
          <p><b>Preferred name</b>: {admin?.preferredName}</p>
          <p><b>Date of Birth:</b> {formatDateToSydneyTimeZone(admin?.dateOfBirth)}</p>
        </div>

        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
          <p><b>Phone:</b> {admin?.phoneNumber}</p>
          <p><b>Email:</b> {admin?.email}</p>
        </div>

        <p><b>Residential Address:</b> {admin?.residentialAddress}</p>
      </div>

      {user?.permissions?.includes('update-permissions') && (
        <ViewSection
          title="Permissions"
          expandable={true}
          content={
            (
              <div className="flex flex-col gap-2 p-4">
                <p><b>Role</b>: {admin?.role}</p>

                <div className="flex items-center flex-wrap gap-2">
                  {permissions.map(permission => (
                    <button
                      key={permission}
                      onClick={() => handlePermissionTagClicked(permission)}
                      className={`ase-button-primary text-xs px-2 py-1 ${admin?.permissions?.includes(permission) ? 'bg-ase-blue' : '!bg-gray-300 !text-black hover:!bg-blue-600 hover:!text-white'}`}
                    >
                      {permission}
                    </button>
                  ))}
                </div>
              </div>
            )
          }
        />
      )}
    </div>
  )
}

export default AdminUserView;